module.exports = __webpack_public_path__ + "img/4632187.09d0db49.png";